import { DetailDrawer } from "./components/DetailDrawer";
import { Discover } from "./components/Discover";
import { FilterRail } from "./components/FilterRail";
import { Header } from "./components/Header";
import { Identify } from "./components/Identify";
import { Leaderboards } from "./components/Leaderboards";
import { Library } from "./components/Library";
import { ProfileDrawer } from "./components/ProfileDrawer";
import { Chip, mutedColor } from "./components/primitives";
import { useKagami } from "./state/useKagami";

export default function App() {
  const k = useKagami();
  const isDiscover = k.section === "discover";

  return (
    <div style={{ minHeight: "100vh", fontFamily: "var(--font-body)" }}>
      <Header k={k} />

      {/* The rail only exists on Discover; data-rail collapses the grid to a
          single column everywhere else. */}
      <div className="k-shell" data-rail={isDiscover ? "true" : "false"} style={{ paddingTop: 20 }}>
        {isDiscover && <FilterRail k={k} />}

        <main style={{ minWidth: 0 }}>
          {k.loading
            ? <div style={{ padding: "56px 0", textAlign: "center", color: mutedColor(50), fontSize: 13 }}>Loading catalog…</div>
            : (
              <>
                {isDiscover && <Discover k={k} />}
                {k.section === "library" && <Library k={k} />}
                {k.section === "boards" && <Leaderboards k={k} />}
                {k.section === "identify" && <Identify />}
              </>
            )}
        </main>
      </div>

      <DetailDrawer k={k} />
      <ProfileDrawer k={k} />

      <nav className="k-tabs" style={{
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 55, alignItems: "stretch",
        background: "color-mix(in srgb, var(--color-bg) 94%, transparent)", backdropFilter: "blur(12px)",
        borderTop: "1px solid var(--color-divider)",
        padding: "6px 8px calc(6px + env(safe-area-inset-bottom))",
      }}>
        <Chip on={isDiscover} onClick={() => k.setSection("discover")} style={tabStyle}>Discover</Chip>
        <Chip on={k.section === "library"} onClick={() => k.setSection("library")} style={tabStyle}>Library</Chip>
        <Chip on={k.section === "boards"} onClick={() => k.setSection("boards")} style={tabStyle}>Boards</Chip>
        <Chip on={k.section === "identify"} onClick={() => k.setSection("identify")} style={tabStyle}>Identify</Chip>
      </nav>
    </div>
  );
}

const tabStyle = { flex: 1, border: 0, padding: "9px 0", fontSize: 11 } as const;
